import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { dateTime, eur, eurSigned } from "@/lib/format";

export const PriceHistoryDialog = ({ open, onOpenChange, row }) => {
  const [history, setHistory] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const listingId = row?.listing_id;

  useEffect(() => {
    if (!open || !listingId) return;
    setLoading(true);
    setError("");
    api
      .get(`/listings/${listingId}/price-history`)
      .then(({ data }) => setHistory(data.history || []))
      .catch((e) => setError(apiError(e)))
      .finally(() => setLoading(false));
  }, [open, listingId]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="price-history-dialog">
        <DialogHeader>
          <DialogTitle className="text-[15px]">Prijshistorie</DialogTitle>
          <DialogDescription className="text-[12px]">
            Elke waargenomen vraagprijs van deze advertentie sinds de eerste scan.
          </DialogDescription>
        </DialogHeader>
        {loading ? (
          <div className="py-6 text-center text-[13px] text-slate-500">Laden…</div>
        ) : error ? (
          <div className="rounded-sm border border-red-300 bg-red-50 px-3 py-2 text-[12px] text-red-800">
            {error}
          </div>
        ) : history.length === 0 ? (
          <div className="py-6 text-center text-[12px] text-slate-500">
            Nog geen prijswijziging vastgelegd voor deze advertentie.
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Moment</th>
                <th>Vraagprijs</th>
                <th>Wijziging</th>
              </tr>
            </thead>
            <tbody>
              {history.map((item, i) => (
                <tr
                  key={`${item.observed_at || item.created_at}-${item.price}`}
                  data-testid={`price-history-row-${i}`}
                >
                  <td className="num">{dateTime(item.observed_at || item.created_at)}</td>
                  <td className="num font-semibold">{eur(item.price)}</td>
                  <td
                    className={`num ${(item.delta ?? 0) < 0 ? "text-red-700" : "text-slate-600"}`}
                  >
                    {item.delta ? eurSigned(item.delta) : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </DialogContent>
    </Dialog>
  );
};
